import { useBreadcrumbStore } from "@/lib/breadcrumbs";
import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

interface Props {
	/** When true, renders in a smaller font for use alongside the menu bar. */
	compact?: boolean;
}

export function Breadcrumbs({ compact }: Props) {
	const { crumbs } = useBreadcrumbStore();

	if (crumbs.length === 0) return null;

	return (
		<nav
			className={cn(
				"flex items-center gap-1 text-muted-foreground shrink-0",
				compact ? "text-[11px]" : "text-sm",
			)}
		>
			{crumbs.map((crumb, i) => {
				const isLast = i === crumbs.length - 1;
				return (
					<span key={`${crumb.label}-${i}`} className="flex items-center gap-1">
						{i > 0 && <ChevronRight className="h-3 w-3 shrink-0 opacity-40" />}
						{crumb.href && !isLast ? (
							<Link
								to={crumb.href}
								className="hover:text-foreground transition-colors truncate max-w-[160px]"
							>
								{crumb.label}
							</Link>
						) : (
							<span
								className={cn(
									"truncate max-w-[200px]",
									isLast ? "text-foreground font-medium" : "",
								)}
							>
								{crumb.label}
							</span>
						)}
					</span>
				);
			})}
		</nav>
	);
}
